import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
      fetched: false,
      savingInProgress: false,
      receipts_settings: null
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async store({ commit, state, dispatch }, payload){
        updateField(state, {path:'savingInProgress', value:true});
        return await axios.post(this._vm.$apiURL + '/receipts_settings', payload)
        .then((response) => {
          if(response.data && response.data.status === 'success'){
            this._vm.$inform(this._vm.i18n.t('common.operation_success'));
            return response.data.receipts_settings;

          }
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
        })
    },
    async get({ commit, state, dispatch }, payload){
      updateField(state, {path:'receipts_settings', value:null});
      updateField(state, {path:'fetched', value:false});
        return await axios.get(this._vm.$apiURL +`/receipts_settings`)
        .then((response) => {
          if(response.data.status = 'success' ){
            updateField(state, {path:'receipts_settings', value:response.data.receipts_settings});

          }
          updateField(state, {path:'fetched', value:true});
          return true;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
    }
  }
}
